












import { Component, Vue, Prop } from "vue-property-decorator";
import Auth from "@/auth/auth";
import { AuthMode, LoginResult } from "@/auth/types";
import Store from "@/store/store";

@Component({})
export default class Callback extends Vue {
  @Prop([Number]) public mode: AuthMode;

  // MUST set initial value for data properties for them to become
  // reactive. without this if used in template will not auto refresh on change.
  public loading: boolean = true;
  public successful: boolean = false;
  public errored: boolean = false;
  public message: string = "logging you in, please wait ...";

  public redirectHome() {
    this.$router.replace("/");
  }

  public logout() {
    Auth.Logout();
  }

  public mounted() {
    if (this.mode === AuthMode.SilentRenew) {
      // dont process if silent renew, (as not in scope). outer frame will handle.
      return;
    }

    const self = this;
    Auth.LoginUsingHashFragment(self.mode, location.hash)
      .then(res => {
        self.loading = false;
        switch (res[0]) {
          case LoginResult.Success:
            self.successful = true;
            if (self.mode === AuthMode.Callback) {
              self.message = "Success, redirecting ...";
              let redirectPath = Auth.GetCallbackRedirectTo();
              if (!redirectPath || !redirectPath.trim()) {
                redirectPath = "/";
              }
              self.$router.replace(redirectPath);
            } else {
              self.message = "Success";
            }
            break;
          case LoginResult.Error:
            Store.state.User.errored = true;
            self.errored = true;
            self.message =
              res[1] && res[1].trim() ? res[1] : "Error: Failed to login";
            break;
          case LoginResult.Expired:
            self.errored = true;
            self.message = "Error: Login Token Expired";
            break;
          case LoginResult.Forbidden:
            self.errored = true;
            self.message =
              "Forbidden: You do not have access to this application";
            break;
          default:
            self.errored = true;
            self.message = "Error: Unexpected login result";
            break;
        }
      })
      .catch(err => {
        self.loading = false;
        self.errored = true;
        self.message = "Error: Failed to parse the login response";
      });
  }
}
